import React from 'react'
import { INode } from 'shared/types/tree'
import { Box, Button } from '@mui/material'
import { copyTree, treeManagementUrl } from './TreeActions'
import { directTreeAccessUrl } from 'infrastructure/api'
import { useGetTreeById } from '../../reducers/trees_hooks'
import { openTab } from '../Helpers'

export function CopyAndShare({
  treeId,
  versionId,
}: {
  treeId: string
  versionId: string
}) {
  const { tree } = useGetTreeById({ treeId, versionId })
  const [newLink, setNewLink] = React.useState<string>()
  const [doingIt, setDoingIt] = React.useState(false)

  async function makeCopyAndShare() {
    if (!tree) return
    setDoingIt(true)
    const newTree = await copyAndOpenTab(tree)
    setNewLink(directTreeAccessUrl(newTree))
    setDoingIt(false)
  }

  if (!tree) return <Box>Loading Tree...</Box>
  return (
    <Box>
      <Box padding={'5px 0 10px 5px'}>
        <b>Title: {tree.title}</b>
      </Box>
      <Box>
        <Button onClick={makeCopyAndShare} disabled={doingIt}>
          Make Copy and Share
        </Button>
      </Box>
      <Box>
        <a href={newLink} target={'_blank'}>
          {newLink}
        </a>
      </Box>
    </Box>
  )
}

async function copyAndOpenTab({ tree_id, version }: INode) {
  const { treeId, versionId } = await copyTree({
    treeId: tree_id,
    versionId: version,
  })
  openTab(treeManagementUrl({ treeId, versionId }))
  return { treeId, versionId }
}
